// Phase 36da.99.bk — HTML-escape user-typed text before embedding it
// in print template strings.  Operators type shop-floor instructions
// (English + Marathi) that get spliced into the print preview's HTML
// via template literals; unescaped < > & " ' would either break the
// markup or open an XSS hole in the preview window.
//
// This is a print-side helper (not for React rendering — React handles
// escaping automatically).  Use everywhere we interpolate raw user
// strings into a `<div>${...}</div>` template within a print HTML.
export function escapeHtmlForPrint(s) {
  if (s == null) return "";
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}